import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'linear-indicator',
  standalone: true,
  templateUrl: './linear-indicator.component.html',
  styleUrls: ['./linear-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinearIndicatorComponent {
  @Input() percentage = 0;

  get clampedPercentage(): number {
    const safePercentage = Number(this.percentage);

    if (!Number.isFinite(safePercentage)) {
      return 0;
    }

    return Math.max(0, Math.min(100, safePercentage));
  }

  get isIndeterminate(): boolean {
    return this.clampedPercentage === 0;
  }
}
